// Build and download a vCard 3.0 file for an attendee.
// Mirrors the format used by scripts/apply_attendees.py so the bundled .vcf
// files and on-tap downloads stay consistent.
export function downloadVCard(a) {
  const lines = buildVcard(a);
  const blob = new Blob([lines.join('\r\n')], { type: 'text/vcard;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${a.name.replace(/[^\w]+/g, '_').replace(/^_|_$/g, '')}.vcf`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 5000);
}

function buildVcard(a) {
  const { given, family, suffix } = parseName(a.name);
  return [
    'BEGIN:VCARD',
    'VERSION:3.0',
    `N:${esc(family)};${esc(given)};;;${esc(suffix)}`,
    `FN:${esc(a.name)}`,
    a.title && `TITLE:${esc(a.title)}`,
    a.organization && `ORG:${esc(a.organization)}`,
    a.phone && `TEL;TYPE=WORK,VOICE:${esc(a.phone)}`,
    a.email && `EMAIL;TYPE=INTERNET,WORK:${esc(a.email)}`,
    a.website && `URL;TYPE=WORK:${formatUrl(a.website)}`,
    'END:VCARD',
  ].filter(Boolean);
}

function parseName(full) {
  // Strip trailing credentials (e.g. ", CAE" or ", DC") into the suffix slot.
  const m = full.match(/^(.+?)(?:,\s*(.+))?$/);
  const base = (m?.[1] || full).trim();
  const suffix = (m?.[2] || '').trim();
  const parts = base.split(/\s+/);
  if (parts.length === 1) return { given: parts[0], family: '', suffix };
  return { given: parts.slice(0, -1).join(' '), family: parts.slice(-1)[0], suffix };
}

function formatUrl(u) {
  if (!u) return '';
  return /^https?:\/\//i.test(u) ? u : `https://${u}`;
}

function esc(v) {
  if (!v) return '';
  return String(v).replace(/([,;\\])/g, '\\$1').replace(/\n/g, '\\n');
}
